export enum TransactionType {
    Charge = 0,
    Credit = 1,
    PromotionalCredit = 2,
    ReferralCredit = 3,
    Refund = 4,
}
